
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import * as n from "@/types/notifications";
import { configStore } from "@/store/store-accessor";
import TroubleshootingModal from "./TroubleshootingModal.vue";
import CopyButton from "@/components/Reusable/CopyButton.vue";
import { jsonStringifyOrUndefined } from "@/util/json-stringify-or-undefined";

@Component({
  components: {
    CopyButton,
    TroubleshootingModal
  }
})
export default class NetworkError extends Vue {
  @Prop()
  value!: n.NetworkErrorNotification;

  moreInfoDialogOpen = false;

  get valueForClipboard(): string | undefined {
    return jsonStringifyOrUndefined(this.value);
  }

  get troubleShootingModalOptions() {
    return { title: "AJAX Error" };
  }

  get loginURL() {
    return configStore.neededData?.adminLoginUrl;
  }

  get isResponseCodeUnauthorized() {
    return this.value.requestDetails?.responseCode === "401";
  }

  setMoreInfoDialogOpen(open: boolean) {
    this.moreInfoDialogOpen = open;
  }
}
